import {Component, OnInit} from '@angular/core';
import {Ship} from '../../Ship';
import {ShipService} from '../../services/ship.service';
import {Router} from '@angular/router';
import {EntitlementService} from '../../services/entitlement.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-hull-swaps',
  templateUrl: './hull-swaps.component.html',
  styleUrls: ['./hull-swaps.component.css']
})
export class HullSwapsComponent implements OnInit {
  ship: Ship;
  shipResultArray: Ship[];
  shipProfiles: Ship[];
  desShip: Ship;
  stripSwapSuccessFail: string;
  stripSwapCircle: string;
  stripSwapCircleCheck: string;
  stripSwapStatus: string;
  swap_btn = false;
  swap_btn_spinner: string;
  shipSwapForm: UntypedFormGroup;
  hasFormError = false;
  hasSameShip = false;

  constructor(private shipService: ShipService,
              private entitlementService: EntitlementService,
              private router: Router) { }

  ngOnInit() {
    this.ship = this.shipService.retrieveShipProfile();
    this.shipResultArray = this.shipService.retieveAllShipProfileResults();
    if (this.ship == null) {
      this.router.navigate(['/shipProfiles']);
    }
    this.shipService.getShipProfiles().subscribe(
      (data: Ship[]) => this.shipProfiles = data,
      error => console.log('Error retrieving ship profiles: ' + error)
    );
    this.initForm();
  }

  initForm() {
    this.shipSwapForm = new UntypedFormGroup({
      'desShip': new UntypedFormControl('0: undefined', [Validators.required])
    });
    this.shipSwapForm.valueChanges.subscribe(
      (newValue: string) => {
        if (newValue['desShip'] === this.ship.shipLocation || newValue['desShip'] === undefined) {
          this.hasFormError = true;
          if (newValue['desShip'] === this.ship.shipLocation) {
            this.hasSameShip = true;
          } else {
            this.hasSameShip = false;
          }
        } else {
          this.hasFormError = false;
        }
      }
    );
  }

  onShipChange(newShip: Ship) {
    this.ship = newShip;
    this.shipService.storeShipProfile(this.ship);
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  hullSwapShips() {
    if (this.shipSwapForm.value['desShip'] === '0: undefined' || this.shipSwapForm.value['desShip'] === 'undefined') {
      this.hasFormError = true;
      return;
    } else {
      this.hasFormError = false;
    }

    this.swap_btn_spinner = 'fa fa-spinner fa-spin';
    this.swap_btn = true;

    const sourceShip = this.ship.shipLocation;
    const destinationShip = this.shipSwapForm.value['desShip'];

    this.shipService.postHullSwap(sourceShip, destinationShip).subscribe(
      (data) => {
        this.swap_btn_spinner = '';
        this.stripSwapStatus = 'Swap completed successfully';
        this.stripSwapSuccessFail = 'actionSuccess';
        this.stripSwapCircleCheck = 'fa fa-check-circle fa-2x';
        this.stripSwapCircle = 'actionCircle';
        this.swap_btn = false;
      },
      (error) => {
        this.swap_btn_spinner = '';
        this.stripSwapStatus = error.data;
        this.stripSwapSuccessFail = 'actionFail';
        this.stripSwapCircle = 'actionCircle';
        this.swap_btn = false;
      }
    );

  }

}
